import { useAuthMe } from "@bodhistreams/queries";
import { APP_URL, BodhiButton, Logo, VideoBackground } from "@bodhistreams/ui";
import "./Hero.css";

const WHITE_VIDEO_URL =
	"https://bodhistreams-test.b-cdn.net/Static/bg_video.mp4";

const PlayIcon = () => (
	<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M8 5v14l11-7z" />
	</svg>
);

const ChevronDownIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M6 9l6 6 6-6"
			stroke="currentColor"
			strokeWidth="2.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const Hero = () => {
	const { data: authUser, isLoading: isAuthLoading } = useAuthMe();
	const isLoggedIn = !!authUser;

	const scrollToNextSection = () => {
		window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
	};

	const handleGoToApp = () => {
		window.location.href = APP_URL;
	};

	const handleStartFreeTrial = () => {
		window.location.href = `${APP_URL}/login`;
	};

	const handleExploreLibrary = () => {
		document
			.querySelector(".collections-section")
			?.scrollIntoView({ behavior: "smooth", block: "start" });
	};

	return (
		<div className="hero">
			<VideoBackground
				videoUrl={WHITE_VIDEO_URL}
				showBlueGradient={false}
				showTopWhiteGradient={false}
				showBottomWhiteGradient={false}
				showVerticalGradient={true}
				darkOverlayOpacity="rgba(26, 31, 29, 0.45)"
				containerStyle={{ padding: 0, height: "auto" }}
			>
				<div className="hero-container">
					<div className="hero-content">
						<Logo.Favicon hyperlink={true} size={80} />
						<span className="hero-eyebrow">Discover Peace Through Sound</span>
						<p className="hero-subtitle">
							Transform your space with premium wellness music curated for
							meditation, relaxation, and mindful living.
						</p>
						{!isAuthLoading && (
							<div className="hero-actions">
								{isLoggedIn ? (
									<BodhiButton
										variant="primary"
										size="lg"
										icon={<PlayIcon />}
										onClick={handleGoToApp}
										className="hero-listen-now"
									>
										Listen Now
									</BodhiButton>
								) : (
									<>
										<BodhiButton
											variant="primary"
											size="lg"
											icon={<PlayIcon />}
											onClick={handleStartFreeTrial}
										>
											Start Free Trial
										</BodhiButton>
										<BodhiButton
											variant="ghost"
											size="lg"
											onClick={handleExploreLibrary}
										>
											Explore Library
										</BodhiButton>
									</>
								)}
							</div>
						)}
					</div>
				</div>
			</VideoBackground>

			<button
				type="button"
				className="hero-scroll"
				onClick={scrollToNextSection}
				aria-label="Scroll to next section"
			>
				<ChevronDownIcon />
			</button>
		</div>
	);
};

export default Hero;
